import React from "react";
import { Link } from "react-router-dom";

const Table = ({
  columns,
  data,
  type,
  scroll = true,
  className,
  rowClassName,
}) => {
  return (
    <div
      className={`w-full bg-white rounded-xl shadow-xs border border-slate-200 overflow-hidden ${
        className ?? ""
      }`}
    >
      <div className={`${scroll ? "overflow-x-auto overflow-y-auto" : ""} w-full`}>
        <table className="w-full border-collapse text-left text-xs">
          <thead>
            <tr className="bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-400 text-slate-900 border-b border-amber-500">
              {columns
                ?.filter((item) => item)
                .map((column, index) =>
                  column?.title === "PDF" ? (
                    <th
                      key={index}
                      className="px-3 py-2.5 text-center font-extrabold uppercase tracking-wider whitespace-nowrap bg-amber-400 border-r border-amber-500/80"
                    >
                      <Link
                        to={
                          column.link
                            ? column.link
                            : type
                            ? `/pdf/staff/${type}`
                            : `/pdf/staff/market`
                        }
                        target="_blank"
                        className="bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-[10px] font-black px-2 py-0.5 rounded shadow transition active:scale-95 inline-flex items-center gap-0.5"
                      >
                        <span>📄</span>
                        <span>PDF</span>
                      </Link>
                    </th>
                  ) : (
                    <th
                      key={index}
                      className="px-3 py-2.5 font-extrabold uppercase tracking-wider border-r border-amber-500/80 whitespace-nowrap"
                    >
                      {column?.title}
                    </th>
                  )
                )}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {data?.map((item, i) => (
              <tr
                key={i}
                className={`hover:bg-slate-50/80 transition-colors ${
                  rowClassName ? rowClassName(item) : ""
                }`}
              >
                {columns
                  .filter((item) => item)
                  .map((column, index) =>
                    column?.render ? (
                      <td
                        key={index}
                        className="px-3 py-2 text-slate-700 border-r border-slate-200/80 whitespace-nowrap align-middle"
                      >
                        {column?.render(item, i)}
                      </td>
                    ) : column?.title === "PDF" ? (
                      <td
                        key={index}
                        className="px-3 py-2 border-r border-slate-200/80 text-center align-middle"
                      ></td>
                    ) : column?.td ? (
                      column?.td(item)
                    ) : (
                      <td
                        key={index}
                        className="px-3 py-2 text-slate-700 border-r border-slate-200/80 whitespace-nowrap align-middle font-medium"
                      >
                        {item?.[column?.dataIndex]}
                      </td>
                    )
                  )}
              </tr>
            ))}
            {(!data || data?.length === 0) && (
              <tr>
                <td
                  className="px-4 py-8 text-center text-slate-400 font-medium text-xs bg-slate-50"
                  colSpan={columns?.length || 1}
                >
                  📦 No Records Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
